// extracted by css-extract-rspack-plugin
export default {"alert":"_62e86771"};